require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-monika-ross-sash.json") })
        }
      }, "path---interview-monika-ross-sash");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-monika-ross-sash!./.cache/json/interview-monika-ross-sash.json
// module id = 695
// module chunks = 231608221292675